import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';

@Component({
  selector: 'hubs',
  template: `<hubs-sub-menu></hubs-sub-menu>
<ul class="hubs">
  <li class="h3">
    <one-hub [header]="true" (sortColumn)="onSortColumn($event)" [prevHubs]="prevHubs" (gotoPrev)="prevPage()"></one-hub>
  </li>
  <li *ngFor="let hub of hubs"
      [class.selected]="hub === currentHub"
      (click)="gotoDetail(hub)">
    <one-hub [inHub]="hub"></one-hub>
  </li>
  <li class="h3" *ngIf="!!hubs && hubs.length >= pageLimit">
    <one-hub [footer]="true" (gotoNext)="nextPage()"></one-hub>
  </li>
</ul>
`,
  styles: [
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.hubs { margin: 0 0 2em 0; list-style-type: none; padding: 0; min-width: 32em; width: 100%; }`,
    `.hubs li { display: block; background-color: #EEE; margin: 0.2em 0; vertical-align: middle; }`,
    `.hubs li:hover { color: #304D6B; background-color: #DDD; }`,
  ],
  providers: [HubService],
})
//  [style.background-color]="this.getColorFor(hub)"


export class HubsComponent implements OnInit {
  hubs: Hub[];
  private fromHubs: number[] = [];
  pageLimit: number = 200;
  prevHubs: boolean = false;
  allHubs: Hub[];
  fromHub: number = 0;
  currentHub: Hub;
  currentPath: string;
  errorMessage: any;
  matchingParams: string[] = [];
  sortColumn: string;
  sortAscending: boolean;
  sortNumeric: boolean;

  constructor(
    private hubService: HubService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.activatedRoute.url.subscribe( (url: UrlSegment[]) => {
      // console.log('URL: ' + JSON.stringify(url, null, 2));
      this.currentPath = '/' + url[0].path + '/' + url[1].path;
      if (url.length > 2) {
        this.matchingParams[url[1].path] = url[2].path;
        // console.log('Params are ', JSON.stringify(this.matchingParams, null, 2));
      } else {
        let pMap = url[url.length - 1].parameterMap;
        for (let key of pMap.keys) {
          this.matchingParams[key] = pMap.get(key);
        }
        // console.log('Params for ' + url.length + ' are ', JSON.stringify(this.matchingParams, null, 2));
      }
      this.getHubs();
    });
  }

  getHubs(): void {
    console.log('Path is ', this.currentPath, ', version is: ' + this.matchingParams['version']);
    console.log('Params are ', JSON.stringify(this.matchingParams, null, 2));
    let observer: Observable<Hub[]>;
    switch (this.currentPath) {
      case '/hubs/version':
        let version = this.matchingParams['version'];
        AppComponent.SetTitle('All Hubs with Version ' + version);
        observer = this.hubService.getHubs(this.pageLimit, version, null, this.fromHub);
        break;
      case '/hubs/health':
        let health = this.matchingParams['health'];
        AppComponent.SetTitle('All Hubs with Health ' + health);
        observer = this.hubService.getHubs(this.pageLimit, null, health, this.fromHub);
        break;
      default:
        AppComponent.SetTitle('All Hubs');
        observer = this.hubService.getOperationalHubs(this.pageLimit, this.fromHub);
        break;
    }
    observer.subscribe(
      hubs => this.updatedHubs(hubs),
      error => this.errorMessage = <any>error,
    );
  }

  private updatedHubs(newHubs: Hub[]): void {
    let processed: Hub[] = [];
    for (let hub of newHubs) {
      if (hub.installed) {
        hub.installed = hub.installed.substr(0,10);
      }
      processed.push(hub);
    }
    this.allHubs = processed;
    try {
      this.matchHubs();
    } catch (e) {
      this.hubs = this.allHubs;
    }
    this.prevHubs = this.fromHubs && (this.fromHubs.length > 0);
  }

  private matchHubs(): void {
    this.hubs = this.allHubs;
    if (!!this.sortColumn) {
      this.sortHubs();
    }
  }

  onSortColumn(e: string) {
    let columnSort = e.split(':');
    this.sortBy(columnSort[0], columnSort[1] === 'true');
  }

  nextPage() {
    console.log("Next page...");
    if (this.hubs) {
      // if (!this.fromHubs) this.fromHubs = [];
      this.fromHubs.push(this.hubs[0].hubid);
      this.fromHub = this.hubs[this.hubs.length-1].hubid;
      this.getHubs();
    }
  }

  prevPage() {
    console.log("Previous page...");
    if (this.fromHubs) {
      this.fromHub = this.fromHubs.pop();
      this.getHubs();
    }
  }

  sortBy(column: string, numeric: boolean): void {
    if (this.sortColumn && this.sortColumn === column) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortColumn = column;
      this.sortNumeric = numeric;
      this.sortAscending = true;
    }
    this.sortHubs();
  }

  private sortHubs(): void {
    let sortColumn = this.sortColumn;
    let sortNumeric = this.sortNumeric;
    let sortAscending = this.sortAscending;
    this.hubs.sort(function(a, b) {
      let result = 0;
      try {
        let f1 = a[sortColumn];
        let f2 = b[sortColumn];
        if (sortNumeric) {
          result = f1 - f2;
        } else {
          result = (f1 < f2 ? -1 : (f1 > f2 ? 1 : 0));
        }
        if (!sortAscending) {
          result *= -1;
        }
      } catch (e) {
        console.log(e.message);
        console.log(`sortColumn: ${sortColumn}`);
        console.log(`a: ${JSON.stringify(a, null, 2)}`);
      }
      return result;
    });
  }

  gotoDetail(hub: Hub): void {
    this.router.navigate(['/hub', hub.hubid]);
  }

}

